import { motion } from "framer-motion";
import MovingTruckBackground from "../components/ui/MovingTruckBackground";

import globe from "../assets/images/hero/globe.png";
import shield from "../assets/images/hero/shield.png";
import logo from "../assets/images/logo1.png";
import logoNew from "../assets/images/hero/msclogonew.png";

const Hero = () => {
  const isMobile = window.innerWidth < 768;

  const scrollToServices = () => {
    const el = document.getElementById("services");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="home"
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        background:
          "linear-gradient(180deg, #ffffff 0%, #f6f9ff 55%, #eef4ff 100%)",
      }}
    >
      {/* Background Truck */}
      <MovingTruckBackground />

      {/* Blue Glow */}
      {!isMobile && (
        <motion.div
          animate={{ rotate: [0, 8, 0] }}
          transition={{
            duration: 22,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={{
            position: "absolute",
            right: "-18%",
            top: "-20%",
            width: "60vw",
            height: "60vw",
            background:
              "radial-gradient(circle, rgba(37,99,235,0.18), transparent 65%)",
            filter: "blur(60px)",
            borderRadius: "50%",
            zIndex: 1,
          }}
        />
      )}

      {/* Right Side Icons */}
      {!isMobile && (
        <div
          style={{
            position: "absolute",
            right: "6%",
            top: "24%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px",
            zIndex: 5,
          }}
        >
          {/* MSC Logo */}
          <motion.img
            src={logo}
            alt="MSC Natraj"
            animate={{ y: [0, -12, 0] }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            style={{
              width: "90px",
              opacity: 0.95,
            }}
          />

          {/* Maruti Supply Chain */}
          <motion.img
            src={logoNew}
            alt="Maruti Supply Chain"
            animate={{ y: [0, -10, 0] }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 0.3,
            }}
            style={{
              width: "180px",
              maxWidth: "100%",
              height: "auto",
              marginTop: "-8px",
              marginBottom: "8px",
              opacity: 0.95,
            }}
          />

          {/* Globe */}
          <motion.img
            src={globe}
            alt="Nationwide"
            animate={{
              y: [0, -18, 0],
              rotate: [0, 4, 0],
            }}
            transition={{
              duration: 7,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            style={{
              width: "72px",
              opacity: 0.85,
            }}
          />

          {/* Shield */}
          <motion.img
            src={shield}
            alt="Secure"
            animate={{
              y: [0, 16, 0],
              rotate: [0, -4, 0],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            style={{
              width: "64px",
              opacity: 0.85,
            }}
          />
        </div>
      )}

      {/* Left Content */}
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1,
          ease: "easeOut",
        }}
        style={{
          position: "relative",
          zIndex: 10,
          maxWidth: "900px",
          paddingTop: isMobile ? "120px" : "200px",
          paddingLeft: isMobile ? "24px" : "96px",
          paddingRight: isMobile ? "24px" : "0px",
          textAlign: isMobile ? "center" : "left",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            letterSpacing: "2px",
            textTransform: "uppercase",
            fontWeight: 600,
            color: "#2563eb",
            marginBottom: "18px",
            display: "block",
          }}
        >
          Pan-India Logistics Partner
        </span>

        <h1
          style={{
            fontSize: isMobile ? "42px" : "72px",
            lineHeight: "1.05",
            fontWeight: 800,
            marginBottom: "26px",
            color: "#0b1f2a",
          }}
        >
          Moving Businesses
          <br />
          <span style={{ color: "#2563eb" }}>
            With Precision
          </span>
        </h1>

        <p
          style={{
            fontSize: isMobile ? "16px" : "18px",
            maxWidth: "650px",
            color: "#425a6b",
            lineHeight: "1.8",
            marginBottom: "26px",
          }}
        >
          We deliver transportation solutions built on operational discipline,
          time-bound execution, and uncompromising service quality. Every
          movement is planned with efficiency, executed with punctuality, and
          monitored with absolute accountability — enabling businesses to
          operate with confidence, consistency, and control.
        </p>

        <motion.div
          onClick={scrollToServices}
          whileHover={!isMobile ? { y: -2 } : {}}
          whileTap={isMobile ? { scale: 0.96 } : {}}
          style={{
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 600,
            color: "#2563eb",
            letterSpacing: "0.4px",
            display: "inline-block",
            borderBottom: "1px solid rgba(37,99,235,0.35)",
            paddingBottom: "4px",
          }}
        >
          Explore Services →
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;